import React, { useCallback, useEffect, useState } from 'react';
import { Box, Card } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import MaterialTypeGrid from './MaterialTypeGrid';

const ResultsTable = ({ data = [], loading = false }) => {
    const [expandedRowIds, setExpandedRowIds] = useState([]);

    useEffect(() => {
        setExpandedRowIds([]);
    }, [data]);

    // Detail panel content for Material Types within a Location
    const getDetailPanelContent = useCallback(({ row }) => {
        if (!row || !row.materialTypes) return null;
        return (
            <MaterialTypeGrid
                materialTypes={row.materialTypes}
                locationName={row.locationName}
            />
        );
    }, []);

    // Column definitions for the main location table
    const columns = [
        {
            field: 'locationName',
            headerName: 'Location Name',
            flex: 2,
        },
        {
            field: 'startWeightLbs',
            headerName: 'Start Weight (lbs)',
            type: 'number',
            valueFormatter: (value) => value?.toLocaleString() || '0',
        },
        {
            field: 'startWeightMt',
            headerName: 'Start Weight (Mt)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
        {
            field: 'endWeightLbs',
            headerName: 'End Weight (lbs)',
            type: 'number',
            valueFormatter: (value) => value?.toLocaleString() || '0',
        },
        {
            field: 'endWeightMt',
            headerName: 'End Weight (Mt)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
        {
            field: 'differenceLbs',
            headerName: 'Difference (lbs)',
            type: 'number',
            valueFormatter: (value) => value?.toLocaleString() || '0',
        },
        {
            field: 'differenceMt',
            headerName: 'Difference (Mt)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
        {
            field: 'potentialEmissions',
            headerName: 'Potential Emissions (MtCO₂e)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
    ];

    return (
        <Box sx={{ mt: 4 }}>
            <Card variant="outlined" style={{ height: 1000 }}>
                <DataGridPro
                    rows={data}
                    columns={columns}
                    loading={loading}
                    disableRowSelectionOnClick
                    hideFooter
                    getDetailPanelContent={getDetailPanelContent}
                    getDetailPanelHeight={() => 'auto'}
                    detailPanelExpandedRowIds={expandedRowIds}
                    onDetailPanelExpandedRowIdsChange={(newIds) => setExpandedRowIds(newIds)}
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
                    localeText={{
                        noRowsLabel: 'No locations found. Try adjusting your filters.',
                    }}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'linear-progress',
                            noRowsVariant: 'linear-progress',
                        },
                    }}
                    sx={{
                        border: 'none',
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                        '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
                            flex: 1,
                        },
                    }}
                />
            </Card>
        </Box>
    );
};

export default ResultsTable;
